<template>
  <el-dialog title="关联回款"
             :visible="visible"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :show-close="false"
             width="35%">
    <el-form ref="form"
             :model="form"
             :rules="assocFormRules"
             size="medium"
             label-width="80px">
      <div class="re-el-form__flex">
        <div class="medium">
          <el-form-item label="回款ID"
                        prop="id">
            <remote-select style="width: 100%;"
                           v-model="form.id"
                           filterable
                           remote
                           clearable
                           id-key="id"
                           label-key="desc"
                           keyword-key="id"
                           value-key="id"
                           :label="customerLabel"
                           placeholder="请输入回款ID进行搜索"
                           :queryParams="{is_from_finance: 1}"
                           :query-request="getReceivedPaymentTable"
                           :find-request="findReceivedPaymentDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="关联金额"
                        prop="assoc_amount">
            <el-input v-model="form.assoc_amount"
                      placeholder="请输入关联金额"></el-input>
          </el-form-item>
          <div style="margin:0 auto; text-align:right;">
            <el-button @click="closeDialog(false)">取消</el-button>
            <el-button type="primary"
                       @click="onSubmit()">确定
            </el-button>
          </div>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { assocFormRules } from '../invoice-apply.rules'

export default {
  components: {},
  props: {
    visible: Boolean,
    detailItemId: Number,
  },
  data () {
    return {
      assocFormRules,
      form: {
        id: '',
        assoc_amount: ''
      },
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$confirm(`请确认本次关联回款ID：${this.form.id} 关联金额：${this.form.assoc_amount}元`, '关联回款操作确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            request.common('invoiceReceivedAssociation', {
              row_id: this.detailItemId, // 开票申请单条目详情ID
              received_id: this.form.id, // 回款单ID
              apply_id: this.$route.params.id, // 开票申请单ID
              assoc_amount: this.form.assoc_amount, // 回款金额
            }).then(() => {
              this.$message.success('回款成功')
              this.closeDialog(true)
            })
          }).catch(() => {
            Object.assign(this.$data, this.$options.data())
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    closeDialog (refresh = false) {
      Object.assign(this.$data, this.$options.data())
      this.$emit('closeDialog', refresh)
    },
    getReceivedPaymentTable (query) {
      return request.common('getNewReceivedPaymentTable', query)
    },
    findReceivedPaymentDetail (id) {
      return request.common('getNewReceivedPaymentDetail', {id})
    },
    customerLabel (item) {
      return `${item.desc}/${item.id}`
    },

  }
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/AffiliatedReturnDialog.vue